















































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import * as data from "../../_store/data.module"
import { bus } from "../../main"
import * as user from "../../_store/user.module"

@Component
export default class DetailsEnterpriseInfoTab extends Vue {
  @Prop() info!: EnterpriseInfo;
  @Prop() userType!: string;
  private stateName: string
  private comuneName: string
  private provinciaName: string

  private ruoloUtente: number[]

  constructor(){
    super()
    this.stateName = ""
    this.comuneName = ""
    this.provinciaName = ""
    this.ruoloUtente = []
  }

  get isDittaIdividuale() {
    var valid = false;
    valid = /^[a-zA-Z]{6}[a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{3}[a-zA-Z]$/.test(
      this.info.pIva
    );
    return valid;
  }

  created() {
    var userInfo = user.readUserInfo(this["$store"])
    this.ruoloUtente = userInfo.ruoloUtente
    // bus.$on("stateName", (data: any) =>{
    //   this.stateName = data
    // })

    // bus.$on("comuneName", (data: any) =>{
    //   this.comuneName = data.località
    //   this.provinciaName = data.provincia
    // })
  }
}
